import { useQuery } from "@tanstack/react-query";

import { GetApiInternalNotificationsParams, ModelsNotification } from "@/schemas";
import { getApiInternalNotifications } from "@/shared/api/auth";
import { createQueryOptions } from "@/shared/lib/api";

interface NotificationsResponse {
    data?: {
        notifications?: ModelsNotification[];
    };
}

export const useGetNotifications = (props: GetApiInternalNotificationsParams) => {
    return useQuery(
        createQueryOptions<NotificationsResponse, ModelsNotification[]>({
            queryKey: ["getApiInternalNotifications", props],
            queryFn: () => getApiInternalNotifications(props),
            preset: "static",
            select: (response) => response.data?.notifications || [],
        }),
    );
};
